import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';
import { permissionGuard } from './core/auth/permission.guard';

export const routes: Routes = [
  { path: 'login', loadComponent: () => import('./login/login').then(m => m.LoginComponent) },
  { path: '', redirectTo: 'home', pathMatch: 'full' },

  {
    path: 'home',
    canActivate: [authGuard],
    loadComponent: () => import('./shell/home/home').then(m => m.HomeComponent),
  },

  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () => import('./shell/layout/layout').then(m => m.Layout),
    children: [
      { path: 'matplan', loadChildren: () => import('./features/matplan/matplan.routes').then(m => m.MATPLAN_ROUTES) },
      { path: 'stammdaten', loadChildren: () => import('./features/stammdaten/stammdaten.routes').then(m => m.STAMMDATEN_ROUTES) },
      { path: 'deko', loadChildren: () => import('./features/deko/deko.routes').then(m => m.DEKO_ROUTES) },
      { path: 'settings', canActivate: [permissionGuard('admin')], loadChildren: () => import('./features/settings/settings.routes').then(m => m.SETTINGS_ROUTES) },
    ],
  },

  { path: '**', redirectTo: 'home' },
];
